import { CardsBlogTemplate } from './CardsBlogTemplate';

export type { TypeCardsBlogTemplateProps } from './types';
export default CardsBlogTemplate;
